import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ValidationService } from 'src/app/shared/services/validation.service';
import { ApiUrlService } from 'src/app/shared/services/api-url.service';
import { HttpService } from 'src/app/shared/services/http-service';
import { ToastrService } from 'ngx-toastr';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import Swal from 'sweetalert2';
declare var Cropper: any;
@Component({
  selector: 'app-evalution2',
  templateUrl: './evalution2.component.html',
  styleUrls: ['./evalution2.component.scss']
})
export class Evalution2Component implements OnInit {
  evalutioncategoryform: FormGroup;
  displayedColumns: string[] = ['sno', 'image', 'name', 'description', 'edit', 'delete', 'view'];
  dataSource: MatTableDataSource<any>;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  userid: any;
  submitted: boolean = false;
  editItem: any = null;

  constructor(
    private modalService: NgbModal,
    private fb: FormBuilder,
    private validation: ValidationService,
    private http: HttpService,
    private apiurl: ApiUrlService,
    private toaster: ToastrService,
    private activatedroute: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.userid = localStorage.getItem('user_id');
    this.formbuilder();
    this.GetEvalutionCategory();
  }
  ngAfterViewInit() {
    const image = document.getElementById('imageToCrop') as HTMLImageElement;
    if (image) {
      this.cropperInstance = new Cropper(image, {
        // aspectRatio:false, 
        zoomable: true,
        scalable: true,
        viewMode: 0
      });

    }
  }
  // async onFileChange(event: Event): Promise<void> {
  //   const input = event.target as HTMLInputElement;

  //   if (input?.files && input.files.length > 0) {
  //     const file = input.files[0];
  //     this.selectedFile = file
  //     this.evalutioncategoryform.patchValue({
  //       image: file
  //     });
  //     this.evalutioncategoryform.get('image')?.markAsTouched();
  //   }
  // }
  croppedImage: string | null = null;
  dropdownOpen = false;
  imageSelected = false
  updatecropped: string | null = null;
  imgdata: any = ''
  private cropperInstance: any;

  // onFileChange(event: Event) {
  //   const input = event.target as HTMLInputElement;
  //   this.imgdata = input.files[0]
  //   this.evalutioncategoryform.patchValue({
  //     image: input.files[0]
  //   });
  //   if (input.files && input.files.length) {
  //     this.imageSelected = true;
  //     const reader = new FileReader();

  //     reader.onload = () => {
  //       const img = document.getElementById('imageToCrop') as HTMLImageElement;
  //       img.src = reader.result as string;

  //       img.onload = () => {
  //         if (this.cropperInstance) {
  //           this.cropperInstance.destroy();
  //         }

  //         this.cropperInstance = new Cropper(img, {
  //           aspectRatio: 0,
  //           zoomable: false,
  //           scalable: false,
  //           viewMode: 0,
  //           responsive: true,
  //           autoCropArea: 1,
  //           background: false
  //         });
  //       };
  //     };

  //     reader.readAsDataURL(input.files[0]);
  //   }
  // }
  onFileChange(event: Event) {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];

    if (file) {
      // Check if file is less than or equal to 5MB
      const maxSizeInMB = 5;
      const maxSizeInBytes = maxSizeInMB * 1024 * 1024;

      if (file.size > maxSizeInBytes) {
        this.evalutioncategoryform.get('image')?.setErrors({ maxSize: true });
        this.imgdata = null;
        this.imageSelected = false;
        this.croppedImage = null;
        input.value = '';
        return;
      }

      this.imgdata = file;
      this.evalutioncategoryform.patchValue({ image: file });
      this.imageSelected = true;

      const reader = new FileReader();
      reader.onload = () => {
        const img = document.getElementById('imageToCrop') as HTMLImageElement;
        img.src = reader.result as string;

        img.onload = () => {
          if (this.cropperInstance) {
            this.cropperInstance.destroy();
          }

          this.cropperInstance = new Cropper(img, {
            aspectRatio: 1,
            zoomable: false,
            scalable: false,
            viewMode: 0,
            responsive: true,
            autoCropArea: 1,
            background: false,
          });
        };
      };

      reader.readAsDataURL(file);
    }
  }

  onImageError(event: any) {
    event.target.src = './assets/images/02image.png'; // fallback image path
  }
  cropImage() {
    if (this.cropperInstance) {
      const canvas = this.cropperInstance.getCroppedCanvas();
      this.croppedImage = canvas.toDataURL('image/png');
      this.updatecropped = this.croppedImage;
      this.imgdata = this.dataURItoBlob(this.croppedImage)
      this.evalutioncategoryform.patchValue({
        image: this.imgdata
      });
    }
  }
  dataURItoBlob(dataURI: string): Blob {
    const byteString = atob(dataURI.split(',')[1]);
    const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }

    return new Blob([ab], { type: mimeString });
  }
  modalImageUrl: string = '';
  onImageClick(content, imageUrl: string) {

    this.modalImageUrl = imageUrl;
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', size: 'lg', centered: true });
  }
  formbuilder(isEdit = false) {
    if (isEdit) {
      this.evalutioncategoryform = this.fb.group({
        title: ['', this.validation.name],
        content: ['', this.validation.msgBody],
        image: ['']
      });
    } else {
      this.evalutioncategoryform = this.fb.group({
        title: ['', this.validation.name],
        content: ['', this.validation.msgBody],
        image: ['', this.validation.required]
      });
    }
  }
  isEdit = false
  async openAddEditModel(content, item: any = null) {
    this.imgdata=''
    this.evalutioncategoryform.reset()
    this.croppedImage = ""
    this.updatecropped = ""
    this.imageSelected = false
    this.submitted = false;
    this.evalutioncategoryform.reset();
    this.editItem = item;

    this.isEdit = false

    if (item) {
      this.formbuilder(true)
      this.isEdit = true
      this.evalutioncategoryform.patchValue({
        title: item.title,
        content: item.content
      });
    } else {
      this.formbuilder()
    }
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', centered: true });
  }

  selectedFile: any
  async AddOrEditEvalutionCategory() {
      this.submitted = true;
      console.log(this.evalutioncategoryform)
    if (this.evalutioncategoryform.invalid) return;
 
    const formData = new FormData();
    formData.append('title', this.evalutioncategoryform.value.title);
    formData.append('content', this.evalutioncategoryform.value.content)
    if (this.imgdata) {
      formData.append('image', this.imgdata);
    }
    if (this.isEdit) {
      formData.append('id', this.editItem.id);
    }
    const url = this.apiurl.url.addevalutioncategory;
    try {
      const result = await this.http.post(url, formData);
      if (result['status']) {
        this.modalService.dismissAll();
        this.evalutioncategoryform.reset();
        this.toaster.success(result['message']);
        this.GetEvalutionCategory();
        this.editItem = {}
      } else {
        this.toaster.error(result['message']);
      }
    } catch (error) {
      console.error(error);
    }
  }


  async DeleteEvalutionCategory(id: number) {
    const confirmation = await Swal.fire({
      title: 'Are you sure?',
      text: 'Do you want to delete this evaluation category?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'Cancel'
    });

    if (confirmation.isConfirmed) {
      try {
        const result = await this.http.post(this.apiurl.url.deleteevalutioncategory, { id });
        if (result['status']) {
          Swal.fire('Deleted!', result['message'], 'success');
          this.GetEvalutionCategory();
        } else {
          Swal.fire('Error!', result['message'], 'error');
        }
      } catch (error) {
        console.error(error);
        Swal.fire('Error!', 'An unexpected error occurred.', 'error');
      }
    }
  }


  async GetEvalutionCategory() {
    try {
      const result = await this.http.post(this.apiurl.url.getevalutioncategory, { user_id: this.userid });
      const data = result['data'] || [];
      this.dataSource = new MatTableDataSource(data);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    } catch (error) {
      console.error(error);
    }
  }
  viewEvaluation(styleId: any) {

    this.router.navigate(['/evaluation'], { queryParams: { styleId: styleId } });

  }

}
